import React, { useState, useEffect, useContext, useRef } from 'react';
import { Box, Card } from '@mui/material';
import checkconfirm from '../../images/check_confirm.svg';
import timer from '../../images/timer.svg';
import Footer from '../Footer';
import imagelogosm from '../../images/neubox-logo.png';
import imagelogo from '../../images/logo-icon.png';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import { fetchInvoice } from '../../services/PaymentManager';
import { AuthContext } from '../../Auth';
import { Error500, ShowError } from '../../alerts/Error';
import { SendPurchaseEvent } from '../../helpers/GTMEventPurchase';
import { useSelector, useDispatch } from 'react-redux';
import { clearResumenDataGTM } from '../../globalslice';

const PaymentConfirm = ({ confirmCost }) => {
    const { t } = useTranslation();
    const { userAuth } = useContext(AuthContext);
    const [countdown, setCountdown] = useState(5);
    const location = useLocation();
    const [cost, setCost] = useState(location?.state || confirmCost); // Initially set cost from location or confirmCost
    const { invoiceId } = useParams();

    const ResumenDataGTM = useSelector(state => state.global.ResumenDataGTM);

    // URL de redireccionamiento cuando el contador llega a cero
    const clientesURL = process.env.REACT_APP_CLIENTES_URL;

    // reinicia valores después de crear orden
    const initialized = useRef(false);
    const dispatch = useDispatch();

    function setTimer() {
        if (countdown > 0) {
            const timerId = setTimeout(() => setCountdown(countdown - 1), 1000);
            return () => clearTimeout(timerId); // Limpia el temporizador al desmontar
        } else if (countdown === 0) {
            // Redirige cuando el contador llega a 0
            window.location.href = clientesURL;
        }
    }

    useEffect(() => {
        // Define async function inside useEffect
        const fetchData = async () => {
            if (invoiceId) {
            try {
                let res = await fetchInvoice(invoiceId, userAuth.token);
                if(res.result == 'success') {
                    setCost(`$${res.amount}`);
                // Solo inicia el temporizador si 'cost' tiene un valor válido (no es null, undefined o 0)
                    if (cost != null && cost !== 0) {
                        if (!initialized.current) {
                            initialized.current = true;
                            
                            // Envio de evento GTM
                            SendPurchaseEvent(ResumenDataGTM.currency, ResumenDataGTM.ResumenData, ResumenDataGTM.cupon, ResumenDataGTM.paymentMethod, ResumenDataGTM.iva, ResumenDataGTM.total, invoiceId);
                            dispatch(clearResumenDataGTM());
                        }
                        setTimer();
                    }
                } else {
                    ShowError(() => console.log('Error msj'), 'Error', res.message);
                }
            } catch (err) {
                Error500('An error occurred while fetching the invoice');
            }
            } else {
                ShowError(() => console.log('Error msj'), 'Error', 'InvoiceId not provided');
            }
        }; 
        fetchData()           
            
      }, [countdown, cost]);

    return (
        <div className="cart-contenido">
            <div className="row row-header">
                <div className="header-center-clean">
                    <img src={imagelogosm} height={38} width={137} alt="Logo Neubox" className="h-logo1" />
                    <img src={imagelogo} alt="Logo Icon" height={34} width={34} className="h-logo2" />
                </div>
            </div>
            <Card variant="outlined" style={{ paddingBottom: '100px' }}>
                <div className="confirm-container">
                    <Box
                        className="confirm-container"
                        sx={{
                            width: '80%',
                            margin: '25px auto 25px',
                            p: 3,
                            borderRadius: '20px',
                            backgroundColor: '#46AA71',
                        }}
                    >
                        <img style={{ marginTop: '8px' }} src={checkconfirm} height={43} width={43} alt="Logo Neubox" />
                        <p className="confirm-text">{t('paymentConfirm.thanks')}</p>
                        <p style={{ marginBottom: '100px' }} className="confirm-text">
                            {t('paymentConfirm.bodyText.title')}
                            <br />
                            {t('paymentConfirm.bodyText.subtitle')}
                        </p>
                    </Box>
                    <Card
                        variant="outlined"
                        className="confirm-container"
                        sx={{
                            width: '50%',
                            margin: '-120px auto 0',
                            p: 3,
                            borderRadius: '20px',
                            backgroundColor: '#FFFFFF',
                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                        }}
                    >
                        <p style={{ color: '#64748B', fontFamily: 'roboto' }}>{t('paymentConfirm.textnote')} #{invoiceId}</p>
                        <p className="confirm-cost">{cost}</p>
                    </Card>
                </div>
                <p style={{ fontSize: '1.2em', textAlign: 'center', color: '#64748B', marginTop: '32px' }}>
                    {t('paymentConfirm.redirectText')}
                </p>
                <div className="flex-center">
                    <div className="flex-center timer-batch">
                        <img style={{ marginRight: '8px' }} src={timer} height={20} width={20} alt="Timer Icon" />
                        <span className="timer-number">{countdown}</span>
                    </div>
                </div>
            </Card>
            <div className="cart-footer">
                <Footer />
            </div>
        </div>
    );
};

export default PaymentConfirm;